module.exports = global["jQuery"] = require("-!/var/lib/jenkins/workspace/TEST2/webapp/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 382
// module chunks = 37